import React, {useState, useEffect, useContext} from 'react'
import styled from 'styled-components';
import UserContext from '../../context/context';

import Modal from '../Nav/Modal'


function Home() {
  const [data, setData] = useState(null)
  const [state, actions] = useContext(UserContext)

  let user = JSON.parse(String(localStorage.getItem('user')))
  // console.log(user)

  let email = String(localStorage.getItem('email'))
  // console.log(email)

  useEffect(()=>{
    async function fetchData(){
      // console.log(localStorage.getItem('user'))
      // console.log(JSON.parse(String(localStorage.getItem('user'))))
      let user = JSON.parse(String(localStorage.getItem('user')))
      // console.log(user.user.email)
      // actions.setIsShowing(true)

      // const res = await fetch(aws_link + "/user/confirm/?user=" + email, {
      //   method: 'GET',
      //   // headers: {Authorization: `JWT ${user.token}`},
      // });
      // res
      //   .json()
      //   .then(res => setData(res))
    }

    // console.log(data)

    if (data === null){
      // console.log("fetching")
      fetchData();
    }

    // console.log("")

    // WebSocketInstance.connect();
    
  })

  // function handleLoginSubmit (user.user.email) {
  //   WebSocketInstance.connect();
  // }

  return(
    <div>HOME
      

    </div>   
  )
}

export default Home;